import React from 'react'
import iconUrl from '../Assets/Logo/logo-icon.svg'
import wordmarkUrl from '../Assets/Logo/logo-wordmark.svg'

/* The logo is two ready-made SVG assets, never drawn in CSS (spec 2, "Logo i
   wordmark"). Wordmark `size` is its letter size: the SVG is 0.98 of that tall
   (cap height + descender) and 4.37 times as wide as tall. */
const WORDMARK_HEIGHT = 0.98
const WORDMARK_RATIO = 428.4 / 98

export function LogoIcon({ size = 36, className = '' }) {
  return (
    <img src={iconUrl} width={size} height={size} alt="" className={`logo-icon ${className}`} />
  )
}

export function Wordmark({ size = 25, className = '' }) {
  const height = Math.round(size * WORDMARK_HEIGHT * 10) / 10
  return (
    <img
      src={wordmarkUrl}
      height={height}
      width={Math.round(height * WORDMARK_RATIO)}
      alt="Instapres"
      className={`wordmark ${className}`}
    />
  )
}

/* Icon left, wordmark right, 10 px apart, vertically centred. */
export function Lockup({ icon = 36, wordmark = 25 }) {
  return (
    <span className="lockup">
      <LogoIcon size={icon} />
      <Wordmark size={wordmark} />
    </span>
  )
}
